<template>
  <div ref="elDivRef" :class="`sys-cell text ${textAlign} ${classes}`">
    <div v-if="formatChars.length > 0" class="amount-box amount">
      <template v-if="highSpeedMode === true">
        {{ formatStr }}
      </template>
      <template v-else>
        <i
          v-for="(item, _index) in formatChars"
          :key="_index"
          :class="formatCharClass(item)"
        >
          {{ item }}
        </i>
      </template>
    </div>
    <div v-else class="def">{{ defaultText }}</div>
  </div>
</template>

<script>
import _ from "lodash";
import math from "@libs/js/mathjs";
import { useFormatAmount, regExpAmountSplit } from "@libs/js/formatAmount";

const { validAmount, isReservedSymbol, inputNumberFilter, formatAmount } =
  useFormatAmount();

export default {
  props: {
    value: { type: [String, Number], default: undefined },
    classes: { type: String, default: "" },
    textAlign: { type: String, default: "right" },
    defaultText: { type: String, default: "--" },
    tooltip: { type: String, default: undefined },
    // 小数点后位数
    fractionLength: { type: Number, default: 2 },
    // 高性能模式
    highSpeedMode: { type: Boolean, default: true },
  },
  computed: {
    formatStr() {
      if (
        _.isNaN(Number(this.value)) ||
        this.value === "" ||
        this.value === undefined
      ) {
        return this.value && this.value.toString();
      } else {
        const arr = math
          .format(math.bignumber(this.value), {
            notation: "fixed",
            precision: this.fractionLength,
            isBankToFixed: true,
          })
          .split(".");

        arr[0] = arr[0].replace(regExpAmountSplit, ",");
        // return "¥" + strVal
        return arr.join(".");
      }
    },
    formatChars() {
      return this.formatStr ? [...this.formatStr] : [];
    },
  },
  methods: {
    formatCharClass(item /* , itemIndex */) {
      switch (item) {
        case ",":
          // return "blue"
          return "";
        case "￥":
        case "¥":
          // return "symbol"
          return "";
        case ".":
          return "";
        case "-":
          // return "dot"
          return "";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@danger-color: #ff5d5d;
@amount-color: #333;
@amount-font-size: 15px;
@amount-font-family: "DIN", "DIN-Bold";

.sys-cell.text {
  display: inline-block;
  vertical-align: middle;
}

.amount-box {
  overflow: hidden;
  pointer-events: none;
  font-size: @amount-font-size;
  // 商户端统一字体样式，不使用DIN作为金额字体
  // font-family: @amount-font-family;
  line-height: 1.5;
  i {
    font-style: normal;
    display: inline-block;
  }

  .symbol {
    margin-right: 3px;
    color: #d9e6ff;
  }
  .grey {
    color: #999;
  }
  .dot {
    margin: 0 2px;
    color: @danger-color;
    // font-weight: bold;
    scale: 1.2;
  }
  .black {
    color: #333;
  }
  .blue {
    color: #a1c3ff;
  }
}
.def {
  color: #999;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.middle {
  display: flex;
  align-items: center;
}
</style>
